import React, {Component, useEffect, useState} from 'react';
import {RouteComponentProps} from '~utils/withRouter';

// import { actionCreators as modalActions } from '~redux/Modal/actions';
// import interestContentActionsCreators from '~redux/ProjectInterestContent/actions';
// import projectDetailActions from '~redux/IIRSAProjectDetail/actions';

import {BasicProps} from './types';
import Layout from './layout';
import {useParams} from "react-router";
import {getProjectDetail} from "~services/IIRSAProjectDetailService";

const IIRSAProjectDetail = (props) => {
    const {id} = useParams();
    const [state, setState] = useState({
        projectDetail: {},
        loading: true,
        openModal: false
    });
    useEffect(() => {
        getProjectDetail(id).then((response) => {
            setState({
                projectDetail: response.data,
                loading: false,
                openModal: false
            });
        });
    }, [id]);

    const {projectDetail, loading, openModal} = state;

    return (
        <Layout
            projectDetail={projectDetail}
            loading={loading}
            id={id}
            openModal={openModal}
        />
    );

}

// const mapStateToProps = state => {
//   return {
//     projectDetail: state.iirsaProjectDetail.iirsaProjectDetail,
//     loading: state.iirsaProjectDetail.iirsaProjectDetailLoading
//   }
// };
//
// const mapDispatchToProps = dispatch => ({
//   getProjectDetail: id => dispatch(projectDetailActions.getProjectDetail(id)),
//   openModal: () => dispatch(modalActions.openModal())
// });

export default IIRSAProjectDetail;
